// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const socialProviders = require('client-v2/common/containers/auth-modal/providers')
const confirmModalActions = require('client-v2/common/containers/confirm-modal/actions')
const routerActions = require('client-v2/common/state/router/actions')
const tag = require('client-v2/common/utils/hyperscript')
// Action types
const APP_DOWNLOAD = 'LOHP_APP_DOWNLOAD'

const providerNames = {}
socialProviders.forEach(provider => {
  providerNames[provider.id] = provider.name
})

// Action dispatchers

function appDownload(platform) {
  return async function (dispatch) {
    dispatch({ type: APP_DOWNLOAD })
    // Send a tracking call
    await businessEvents.trackSegment('app-download', { platform })
  }
}

function maybeShowErrorAlert(queryParams) {
  return function (dispatch) {
    const { error, provider } = queryParams
    if (error) {
      const providerName = providerNames[provider]
      let message = 'Please try again.'
      if (error === 'permission') {
        message = 'Please make sure you are logged-in to your social account, then try again.'
      }
      // Show alert modal on error
      dispatch(confirmModalActions.alert({
        heading: `There was a problem connecting with your ${providerName} account`,
        subheading: tag([
          message,
          '\n',
          'If you continue to have this problem, ',
          tag('a', {
            href: 'mailto:support@mix.com'
          },
            'contact support.'
          )
        ])
      }))
    }
  }
}

function sanitizeLoginQueryParams() {
  return function (dispatch, getState) {
    const { pathname } = getState().router.location
    if (pathname === '/login') {
      // Remove error query parameters from login URL
      dispatch(routerActions.replace({ path: '/login' }))
    }
  }
}

function socialAuth(provider) {
  return async function (dispatch, getState) {
    // Wait for tracking before navigating away from page
    await businessEvents.trackSegment('social-auth', {
      authContext: 'lohp-v2',
      provider
    })
    const { pathname, search } = getState().router.location
    const r = encodeURIComponent(pathname + search)
    const href = `/auth/${provider}?r=${r}`
    dispatch(routerActions.navigate({ href }))
  }
}

module.exports = {
  // Action types
  APP_DOWNLOAD,
  // Action dispatchers
  appDownload,
  maybeShowErrorAlert,
  sanitizeLoginQueryParams,
  socialAuth
}
